// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"vq-z","imageAndVideoCount":"wq-z","imageAndVideoContainer":"xq-z","viewAllReviews":"yq-z"};